import "./App.css";
import CardinhoComp from "./components/cardinho/cardinho";
import HeaderComp from "./components/header/header.jsx";
import CartComp from "./components/cart/cart.jsx";
import DivCardsComp from "./components/divCards/divCards";
import FooterComp from "./components/footer/footer";
import axios from "axios";
import { useState } from "react";
import dataChumbado from "./components/data/data.js";
import CardComp from "./components/card/card.jsx";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from "./services/api";

function App() {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState("");
  const [currentSale, setCurrentSale] = useState([]);

  async function request() {
    setProducts(dataChumbado);
    // try {
    //   const response = await API.get("/products");
    //   setProducts(response.data);

    // } catch (error) {
    //   console.log("error :>> ", error);
    // }
  }

  useEffect(() => {
    request();
    console.log("use effect rodou");
  }, []);

  function trashBin(obj, state, setState) {
    const arr = state.filter((element) => element.id !== obj.id);

    setState([...arr]);
  }

  return (
    <div>
      <HeaderComp setState={setFilteredProducts}> </HeaderComp>
      <div className="container">
        <DivCardsComp>
          {products
            .filter((element) =>
              element.name.toLowerCase().includes(filteredProducts)
            )
            .map((element) => (
              <CardComp
                product={element}
                //state={{ state: currentSale, setState: setCurrentSale }}
                state={currentSale}
                setState={setCurrentSale}
              ></CardComp>
            ))}
        </DivCardsComp>

        <CartComp>
          {currentSale.map((element) => (
            <CardinhoComp
              obj={element}
              state={{ state: currentSale, setState: setCurrentSale }}
              deleteCard={trashBin}
            ></CardinhoComp>
          ))}

          <FooterComp state={currentSale}></FooterComp>
        </CartComp>
        <ToastContainer />
      </div>
    </div>
  );
}

export default App;
